import { render, staticRenderFns } from "./AddShipment.vue?vue&type=template&id=44f0b3b1&"
import script from "./AddShipment.vue?vue&type=script&lang=js&"
export * from "./AddShipment.vue?vue&type=script&lang=js&"
import style0 from "./AddShipment.vue?vue&type=style&index=0&id=44f0b3b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports